var isLocal = function () { return window.location.protocol === 'file:'; };
export default isLocal;
//# sourceMappingURL=is-local.js.map